function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var l = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var w = Object.prototype.hasOwnProperty,
    g = Object.prototype.propertyIsEnumerable;

var e = function e(C, t, o) {
  return t in C ? l(C, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : C[t] = o;
},
    i = function i(C, t) {
  for (var o in t || (t = {})) {
    w.call(t, o) && e(C, o, t[o]);
  }

  if (n) {
    var _iterator = _createForOfIteratorHelper(n(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        g.call(t, o) && e(C, o, t[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return C;
};

import * as r from "react";

function p(C) {
  return r.createElement("svg", i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, C), r.createElement("path", {
    d: "M18.4323 14.9109L16.17 14.6526C15.6267 14.5903 15.0923 14.7773 14.7093 15.1603L13.0704 16.7992C10.5498 15.5166 8.4834 13.4591 7.20082 10.9295L8.84858 9.28177C9.23157 8.89878 9.41862 8.36436 9.35627 7.82104L9.09797 5.57651C8.99109 4.67692 8.23401 4 7.32551 4H5.78464C4.77816 4 3.94092 4.83725 4.00327 5.84372C4.47533 13.4502 10.5587 19.5247 18.1562 19.9967C19.1627 20.0591 19.9999 19.2218 19.9999 18.2154V16.6745C20.0088 15.7749 19.3319 15.0178 18.4323 14.9109Z",
    fill: "black"
  }));
}

export { p as ReactComponent };